export default __webpack_public_path__ + "static/media/android-download.e29e4208.png";